import request from '../utils/request.js'
import qs from 'qs'
import router from '@/router/index.js'
import { Message, Loading } from 'element-ui'

//未登录函数复用
function CheckToken(res) {
    if (res.data.code == -1001 || res.data.code == -1002) {
        window.sessionStorage.removeItem('token')
        window.sessionStorage.removeItem('userInfo')
        Message.closeAll()
        Message({
            type: 'warning',
            message: '登录失效，请重新登录',
            duration: 1500,
        })
        router.push('/login')
    } else if (res.data.code != 200) {
        Message({
            type: 'warning',
            message: res.data.msg,
            duration: 1500
        })
    }
}

//获取水量信息
function GetWaterCount(data) {
    return new Promise((resolve, reject) => {
        request.post('/api/WaterCount/GetData', data).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

//获取用水类型
function GetWaterType(data) {
    return new Promise((resolve, reject) => {
        request.post('/api/WaterType/GetData', data).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

//获取用水区域
function GetWaterArea(data) {
    return new Promise((resolve, reject) => {
        request.post('/api/Area/GetArea', data).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

//获取业务须知
function GetNotice(path) {
    return new Promise((resolve, reject) => {
        const loading = Loading.service({
            lock: true,
            text: "正在提交",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        request.get(`/api/${path}/GetNotice`).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
            loading.close()
        }).catch(err => {
            reject(err)
        })
    })
}

//获取业务附件
function GetAttached(path) {
    return new Promise((resolve, reject) => {
        const loading = Loading.service({
            lock: true,
            text: "正在提交",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        request.get(`/api/${path}/GetAttr`).then(res => {
            CheckToken(res)
            if (res.data.code == 200) {
                resolve(res)
            }
            loading.close()
        }).catch(err => {
            reject(err)
        })
    })
}

export { GetWaterCount, GetWaterType, GetWaterArea, GetNotice, GetAttached }